import { AutogenModelDestCity, AutogenRowDestCity } from "./autogen/AutogenModelDestCity";

export class ModelDestCity extends AutogenModelDestCity<RowDestCity> {
	constructor() {
		super(RowDestCity);
	}
}

export class RowDestCity extends AutogenRowDestCity {
}